import { breakpoints, matchBreakpoint } from "./common/utils";
$(window).resize(() => {
  matchBreakpoint(breakpoints.md, "min");
  matchBreakpoint(breakpoints.lg, "max");
  matchBreakpoint(breakpoints.md, "max");
});

import "./components/webinars";
